import { render } from "./MarketCard.vue?vue&type=template&id=4bcc42d0"
import script from "./MarketCard.vue?vue&type=script&lang=js"
export * from "./MarketCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__